(() => {
  class EpedalSlider extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.index = 0;
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.dots = [...this.querySelectorAll('[data-slide-index]')];
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button) return;
        if (button.hasAttribute('data-slide-index')) this.show(Number(button.dataset.slideIndex));
        if (button.hasAttribute('data-step')) this.show(this.index + Number(button.dataset.step));
      }, {signal: this.abort.signal});
      document.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide === event.target || slide.contains(event.target));
        if (index >= 0) this.show(index);
      }, {signal: this.abort.signal});
    }
    show(index) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        slide.hidden = i !== this.index;
        if (i === this.index) slide.querySelectorAll('img').forEach(image => image.loading = 'eager');
      });
      this.dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === this.index)));
    }
    disconnectedCallback() { this.abort?.abort(); }
  }
  class EpedalProducts extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.addEventListener('click', event => {
        const step = event.target.closest('[data-product-step]');
        if (step) {
          const grid = this.querySelector('.e24-product-grid');
          grid.scrollBy({left: grid.clientWidth * Number(step.dataset.productStep) * .8, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
          return;
        }
        const button = event.target.closest('[data-filter]');
        if (!button) return;
        this.querySelectorAll('[data-filter]').forEach(filter => filter.setAttribute('aria-pressed', String(filter === button)));
        this.querySelectorAll('[data-product]').forEach(product => product.hidden = button.dataset.filter !== 'all' && product.dataset.product !== button.dataset.filter);
        this.querySelector('.e24-product-grid').scrollTo({left:0,behavior:'instant'});
        this.querySelector('[role="status"]').textContent = button.textContent.trim();
      }, {signal: this.abort.signal});
    }
    disconnectedCallback() { this.abort?.abort(); }
  }
  class EpedalSeries extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
      this.addEventListener('click', event => {
        const tab = event.target.closest('[role="tab"]');
        if (tab) this.select(Number(tab.dataset.series));
      }, {signal: this.abort.signal});
      this.addEventListener('keydown', event => {
        const current = this.tabs.indexOf(event.target);
        if (current < 0) return;
        let next;
        if (['ArrowDown','ArrowRight'].includes(event.key)) next = (current + 1) % this.tabs.length;
        if (['ArrowUp','ArrowLeft'].includes(event.key)) next = (current - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        this.select(next);
        this.tabs[next].focus();
      }, {signal: this.abort.signal});
      document.addEventListener('shopify:block:select', event => {
        const index = this.panels.findIndex(panel => panel === event.target || panel.contains(event.target));
        if (index >= 0) this.select(index);
      }, {signal: this.abort.signal});
    }
    select(index) {
      this.tabs.forEach((tab, i) => {tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1;});
      this.panels.forEach((panel, i) => panel.hidden = i !== index);
    }
    disconnectedCallback() { this.abort?.abort(); }
  }
  class EpedalAccordion extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.querySelectorAll('details').forEach(detail => detail.addEventListener('toggle', () => {
        if (detail.open) this.querySelectorAll('details').forEach(other => {if (other !== detail) other.open = false;});
      }, {signal: this.abort.signal}));
    }
    disconnectedCallback() { this.abort?.abort(); }
  }
  for (const [name, implementation] of [['epedal-slider',EpedalSlider],['epedal-products',EpedalProducts],['epedal-series',EpedalSeries],['epedal-accordion',EpedalAccordion]]) {
    if (!customElements.get(name)) customElements.define(name, implementation);
  }
})();

